import { Box, Button, Header, SpaceBetween, StatusIndicator } from '@amzn/awsui-components-react';
import React, { useState } from 'react';
import { LogRedactionFeedbackWrapper } from '../../Components/LogRedaction/LogRedactionFeedbackWrapper';

interface DiagnosticDumpsListProps {
    loading: boolean;
    data: string[];
    clientId?: string;
    domainName?: string;
    account?: any;
}

export const DiagnosticDumpsList: React.FC<DiagnosticDumpsListProps> = ({
                                                                            loading,
                                                                            data,
                                                                            clientId,
                                                                            domainName,
                                                                            account
                                                                        }) => {
    const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

    if (loading) {
        return <div>Loading diagnostic dumps...</div>;
    }

    if (!data || data.length === 0) {
        return <div>No diagnostic dumps available</div>;
    }

    const handleCopy = async (command: string, index: number) => {
        try {
            await navigator.clipboard.writeText(command);
            setCopiedIndex(index);
            setTimeout(() => setCopiedIndex(null), 2000);
        } catch (err) {
            console.error('Failed to copy command:', err);
        }
    };

    return (
        <Box margin={{ bottom: 'l' }}>
            <SpaceBetween direction="vertical" size="l">
                <Header
                    variant="h3"
                    actions={
                        <SpaceBetween direction="horizontal" size="xs">
                            <LogRedactionFeedbackWrapper
                                buttonContent="Downloading Instructions"
                                isTot={true}
                                domainId={`${clientId}:${domainName}`}
                                account={account}
                            />
                        </SpaceBetween>
                    }
                >
                    Diagnostic Dumps Commands
                </Header>
                <SpaceBetween direction="vertical" size="m">
                    {data.map((command, index) => (
                        <div key={index} style={{ margin: '20px 0' }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                background: '#f8f8f8',
                                padding: '15px',
                                borderRadius: '4px',
                                border: '1px solid #ddd',
                            }}>
                                <pre style={{
                                    margin: 0,
                                    overflowX: 'auto',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-all',
                                    fontFamily: 'monospace',
                                    fontSize: '14px',
                                    lineHeight: '1.4',
                                    flex: 1,
                                    marginRight: '15px'
                                }}>
                                    {command}
                                </pre>
                                <Button
                                    onClick={() => handleCopy(command, index)}
                                    variant="normal"
                                    iconName={copiedIndex === index ? "status-positive" : "copy"}
                                >
                                    {copiedIndex === index ? "Copied!" : "Copy"}
                                </Button>
                            </div>
                        </div>
                    ))}
                </SpaceBetween>
                <p style={{ marginTop: '10px' }}>
                    Run these commands in your terminal to download the diagnostic dumps.
                </p>
            </SpaceBetween>
        </Box>
    );
};